import React, { useRef, useState, useEffect } from 'react';
import test from '../Assets/Data/testimonials.json';
import client from '../Assets/Data/clientnames.json';

const images = require.context('../Assets/images', false, /\.(png|jpe?g|svg)$/);

const Client = () => {
  const carouselRef = useRef(null);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  const updateButtonVisibility = () => {
    const el = carouselRef.current;
    if (!el) return;
    setAtStart(el.scrollLeft <= 10);
    setAtEnd(el.scrollLeft + el.offsetWidth >= el.scrollWidth - 10);
  };

  const scrollNext = () => {
    const el = carouselRef.current;
    if (el) {
      el.scrollBy({ left: el.offsetWidth * 0.8, behavior: 'smooth' });
    }
  };

  const scrollPrev = () => {
    const el = carouselRef.current;
    if (el) {
      el.scrollBy({ left: -el.offsetWidth * 0.8, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    updateButtonVisibility();
    el.addEventListener('scroll', updateButtonVisibility);
    return () => el.removeEventListener('scroll', updateButtonVisibility);
  }, []);

  return (
    <div>
    

      {/* Testimonials Carousel */}

      <h2 className='green-text text-center mt-5 text-xxl'>Real Stories. Real Impact.</h2>
      <div className="carousel-wrap" >
        {!atStart && (
          <button className="nav-btn left" onClick={scrollPrev}>‹</button>
        )}

        <div className="carousel-container">
          <div className="carousel-track" ref={carouselRef}>
            {test.map((item, i) => (
              <div
                key={i}
                className="carousel-card"
                style={{ flex: '0 0 calc(33.33% - 80px)', marginRight: '16px' }}
              >
                <img
                  src={images(`./${item.id}`)}
                  alt={`Testimonial ${i + 1}`}
                  className="carousel-image"
                  style={{
                   
                    height: 'auto',
                    borderRadius: '10px',
                    objectFit: 'cover'
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        {!atEnd && (
          <button className="nav-btn right" onClick={scrollNext}>›</button>
        )}
      </div>
        {/* Client Logo Wall */}
        <h1 className='pink-gradient text-center mt-5'>Logos We Love</h1>
      <div className="client-wall">
        {/* {client.map((item, i) => (
          <img
            key={i}
            src={images(`./${item.id}`)}
            alt={`Client ${i + 1}`}
            className="client-logo"
          />
        ))} */}
        
    <div className="marquee-container">
    <div class="shadow-left"></div>
    <div class="shadow-right"></div>
      <div className="marquee">
        <div className="marquee-track">
        {client.map((item, i) => (
          <img
            key={i}
            src={images(`./${item.id}`)}
            alt={`Client ${i + 1}`}
            className="client-logo"
          />
        ))}
          {/* Duplicate set */}
          {client.map((item, i) => (
          <img
            key={i}
            src={images(`./${item.id}`)}
            alt={`Client ${i + 1}`}
            className="client-logo"
          />
        ))}
        </div>
      </div>
    </div>
    
      </div>
    </div>
  );
};

export default Client;
